var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentsIllustration = function SvgDocumentsIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142,
    height: 132,
    fill: "none",
    viewBox: "0 0 142 132"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#DocumentsIllustration_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#D1D5DB",
    strokeWidth: 0.25,
    d: "m65.592 10.767 70.22 20.135-26.077 90.943-70.22-20.135z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.66,
    height: 2.232,
    x: 66.877,
    y: 13.086,
    fill: "#9FAFC3",
    rx: 1.116,
    transform: "rotate(16 66.877 13.086)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.987,
    height: 2.232,
    x: 63.185,
    y: 25.959,
    fill: "#9FAFC3",
    rx: 1.116,
    transform: "rotate(16 63.185 25.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.991,
    height: 2.232,
    x: 57.033,
    y: 47.414,
    fill: "#9FAFC3",
    rx: 1.116,
    transform: "rotate(16 57.033 47.414)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.991,
    height: 2.232,
    x: 48.413,
    y: 77.479,
    fill: "#9FAFC3",
    rx: 1.116,
    transform: "rotate(16 48.413 77.479)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.66,
    height: 1.116,
    x: 65.646,
    y: 17.377,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 65.646 17.377)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 61.955,
    y: 30.25,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 61.955 30.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 55.803,
    y: 51.705,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 55.803 51.705)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 47.182,
    y: 81.77,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 47.182 81.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.309,
    height: 1.116,
    x: 59.494,
    y: 38.832,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 59.494 38.832)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 53.342,
    y: 60.287,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 53.342 60.287)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 50.881,
    y: 68.869,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 50.881 68.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.66,
    height: 1.116,
    x: 65.031,
    y: 19.523,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 65.03 19.523)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 61.34,
    y: 32.396,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 61.34 32.396)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 55.188,
    y: 53.851,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 55.188 53.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 46.566,
    y: 83.915,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 46.566 83.915)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.309,
    height: 1.116,
    x: 58.879,
    y: 40.978,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 58.879 40.978)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 52.726,
    y: 62.433,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 52.726 62.433)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 50.266,
    y: 71.015,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 50.266 71.015)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.66,
    height: 1.116,
    x: 64.416,
    y: 21.668,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 64.416 21.668)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 60.725,
    y: 34.541,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 60.725 34.541)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 54.572,
    y: 55.996,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 54.572 55.996)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 45.952,
    y: 86.061,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 45.952 86.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.309,
    height: 1.116,
    x: 58.263,
    y: 43.123,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 58.263 43.123)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 52.111,
    y: 64.578,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 52.111 64.578)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 49.651,
    y: 73.16,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(16 49.651 73.16)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#DocumentsIllustration_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#D1D5DB",
    strokeWidth: 0.25,
    d: "M36.602 14.27h73.05v94.608h-73.05z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.66,
    height: 2.232,
    x: 38.477,
    y: 16.146,
    fill: "#9FAFC3",
    rx: 1.116
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.987,
    height: 2.232,
    x: 38.477,
    y: 29.538,
    fill: "#9FAFC3",
    rx: 1.116
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.991,
    height: 2.232,
    x: 38.477,
    y: 51.857,
    fill: "#9FAFC3",
    rx: 1.116
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.991,
    height: 2.232,
    x: 38.477,
    y: 83.133,
    fill: "#9FAFC3",
    rx: 1.116
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.66,
    height: 1.116,
    x: 38.477,
    y: 20.61,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 38.477,
    y: 34.002,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 38.477,
    y: 56.321,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 38.477,
    y: 87.597,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.309,
    height: 1.116,
    x: 38.477,
    y: 42.929,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 38.477,
    y: 65.249,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 38.477,
    y: 74.177,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.66,
    height: 1.116,
    x: 38.477,
    y: 22.842,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 38.477,
    y: 36.234,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 38.477,
    y: 58.553,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 38.477,
    y: 89.829,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.309,
    height: 1.116,
    x: 38.477,
    y: 45.161,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 38.477,
    y: 67.481,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 38.477,
    y: 76.409,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.66,
    height: 1.116,
    x: 38.477,
    y: 25.074,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 38.477,
    y: 38.466,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 38.477,
    y: 60.785,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 38.477,
    y: 92.061,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.309,
    height: 1.116,
    x: 38.477,
    y: 47.393,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 38.477,
    y: 69.713,
    fill: "#E5E7EB",
    rx: 0.558
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 38.477,
    y: 78.641,
    fill: "#E5E7EB",
    rx: 0.558
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#DocumentsIllustration_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#D1D5DB",
    strokeWidth: 0.25,
    d: "m6.188 22.29 70.22-20.135 26.078 90.943-70.22 20.135z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.66,
    height: 2.232,
    x: 8.506,
    y: 23.576,
    fill: "#9FAFC3",
    rx: 1.116,
    transform: "rotate(-16 8.506 23.576)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.987,
    height: 2.232,
    x: 12.197,
    y: 36.449,
    fill: "#9FAFC3",
    rx: 1.116,
    transform: "rotate(-16 12.197 36.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.991,
    height: 2.232,
    x: 18.35,
    y: 57.904,
    fill: "#9FAFC3",
    rx: 1.116,
    transform: "rotate(-16 18.35 57.904)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.991,
    height: 2.232,
    x: 26.971,
    y: 87.969,
    fill: "#9FAFC3",
    rx: 1.116,
    transform: "rotate(-16 26.97 87.969)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.66,
    height: 1.116,
    x: 9.737,
    y: 27.867,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 9.737 27.867)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 13.428,
    y: 40.74,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 13.428 40.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 19.58,
    y: 62.195,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 19.58 62.195)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 28.201,
    y: 92.26,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 28.201 92.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.309,
    height: 1.116,
    x: 15.889,
    y: 49.322,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 15.889 49.322)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 22.041,
    y: 70.777,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 22.041 70.777)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 24.502,
    y: 79.359,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 24.502 79.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.66,
    height: 1.116,
    x: 10.352,
    y: 30.013,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 10.352 30.013)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 14.043,
    y: 42.886,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 14.043 42.886)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 20.195,
    y: 64.341,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 20.195 64.34)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 28.816,
    y: 94.405,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 28.816 94.405)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.309,
    height: 1.116,
    x: 16.504,
    y: 51.468,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 16.504 51.468)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 22.656,
    y: 72.923,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 22.656 72.923)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 25.117,
    y: 81.505,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 25.117 81.505)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.66,
    height: 1.116,
    x: 10.967,
    y: 32.158,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 10.967 32.158)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 14.658,
    y: 45.031,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 14.658 45.031)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 20.81,
    y: 66.486,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 20.81 66.486)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.301,
    height: 1.116,
    x: 29.431,
    y: 96.55,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 29.431 96.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.309,
    height: 1.116,
    x: 17.119,
    y: 53.613,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 17.12 53.613)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 23.272,
    y: 75.068,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 23.272 75.068)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.313,
    height: 1.116,
    x: 25.732,
    y: 83.65,
    fill: "#E5E7EB",
    rx: 0.558,
    transform: "rotate(-16 25.732 83.65)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "DocumentsIllustration_svg__a",
    width: 108.607,
    height: 123.388,
    x: 33.36,
    y: 8.612,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 2,
    result: "effect1_dropShadow_255_1332"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_255_1332"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 2,
    result: "effect2_dropShadow_255_1332"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_255_1332",
    result: "effect2_dropShadow_255_1332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_255_1332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "DocumentsIllustration_svg__b",
    width: 85.3,
    height: 106.858,
    x: 30.477,
    y: 12.145,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 2,
    result: "effect1_dropShadow_255_1332"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_255_1332"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 2,
    result: "effect2_dropShadow_255_1332"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_255_1332",
    result: "effect2_dropShadow_255_1332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_255_1332",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "DocumentsIllustration_svg__c",
    width: 108.607,
    height: 123.388,
    x: 0.033,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 2,
    result: "effect1_dropShadow_255_1332"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_255_1332"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 2,
    result: "effect2_dropShadow_255_1332"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_255_1332",
    result: "effect2_dropShadow_255_1332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_255_1332",
    result: "shape"
  })))));
};
export default SvgDocumentsIllustration;